module.exports = __webpack_public_path__ + "img/history.6d7987da.svg";